module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartthings_guide_step5_img.5371930b.svg";